import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/sso/login',
    method: 'post',
    data
  })
}

// 单点登录 Token 校验/登录（占位接口，后续可按实际调整）
export function ssoTokenLogin(data) {
  return request({
    url: '/sso/bjjhmk/login',
    method: 'post',
    // 将该接口的超时时间单独延长到 1 分钟，不影响其他接口
    timeout: 60000,
    data
  })
}

export function getInfo(token, systemType) {
  return request({
    url: '/sso/getUserInfo',
    method: 'get',
    header: { SystemType: systemType }
  }).then(res => {
    return res
  }).catch(err => {
    throw err
  })
}

export function logout() {
  return request({
    url: '/sso/logout',
    method: 'post'
  })
}

// /updatePwd
export function updatePwd(data) {
  return request({
    url: '/sso/updatePwd',
    method: 'put',
    data
  })
}
// 信息分组
export function group(data) {
  return request({
    url: '/base/paste/group',
    method: 'post',
    data
  })
}
// 新增信息分组
export function groupAdd(data) {
  return request({
    url: '/base/paste/group/add',
    method: 'post',
    data
  })
}
// 分组信息列表
export function pastelist(data) {
  return request({
    url: '/base/paste/list',
    method: 'post',
    data
  })
}
// 新增备注
export function addRemark(data) {
  return request({
    url: '/base/paste/add',
    method: 'post',
    data
  })
}
// 拖拽排序
export function sort(data) {
  return request({
    url: '/base/paste/sort',
    method: 'post',
    data
  })
}
// 删除分组
export function groupDel(data) {
  return request({
    url: '/base/paste/group/del',
    method: 'post',
    data
  })
}
// 信息删除
export function del(data) {
  return request({
    url: '/base/paste/del',
    method: 'post',
    data
  })
}
// 信息编辑
export function edit(data) {
  return request({
    url: '/base/paste/upd',
    method: 'post',
    data
  })
}
// 信息搜索
export function search(data) {
  return request({
    url: '/base/paste/sel',
    method: 'post',
    data
  })
}

export default {
  login,
  ssoTokenLogin,
  getInfo,
  logout,
  updatePwd,
  group,
  groupAdd,
  pastelist,
  addRemark,
  sort,
  groupDel,
  del,
  edit,
  search
}
